import { Image as ImageIcon } from "lucide-react";
import CrudManager from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { title: "", image: "", category: "General", order: 0, published: true };

export default function AdminGallery() {
  return (
    <CrudManager
      title="Gallery"
      subtitle="Upload gallery images — warehouse, showroom, packaging, business meetings."
      endpoint="/admin/gallery"
      defaultItem={DEFAULT}
      testId={ADMIN.galleryList}
      searchKeys={["title", "category"]}
      listRender={(g) => (
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 rounded-sm bg-secondary overflow-hidden shrink-0">
            {g.image ? <img src={g.image} alt={g.title} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-foreground/40"><ImageIcon size={16} /></div>}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] tracking-widest uppercase text-gold">{g.category || "General"}</p>
            <p className="mt-0.5 font-serif text-lg text-foreground truncate">{g.title || "Untitled"}</p>
          </div>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div>
            <Label>Title</Label>
            <Input className="mt-2 rounded-sm" value={v.title} onChange={(e) => patch({ title: e.target.value })} />
          </div>
          <div>
            <Label>Category (Warehouse, Showroom, Business, Packaging, etc.)</Label>
            <Input className="mt-2 rounded-sm" value={v.category} onChange={(e) => patch({ category: e.target.value })} />
          </div>
          <ImageUpload label="Image" value={v.image} onChange={(u) => patch({ image: u })} />
          <div className="grid md:grid-cols-2 gap-4 items-end">
            <div>
              <Label>Display Order</Label>
              <Input type="number" className="mt-2 rounded-sm" value={v.order} onChange={(e) => patch({ order: parseInt(e.target.value) || 0 })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c) => patch({ published: c })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
